import React, { useCallback, useEffect, useRef, useState } from "react"
import { Text, View, Image, FlatList, ScrollView } from 'react-native';

import { debounce } from "lodash";
import { store } from "../../store/store";
import { View as AnimatableView } from "react-native-animatable";

import { getImagePath, isObjectNotEmpty } from "../../utils/services/CommonUtils";
import { refreshChemistData } from "../../utils/services/chemist/ChemistStoreUtils";
import { updateOrderList, updateOrderInstructions } from "../../utils/services/redux/commonRedux";
import { getAddressFromUserSavedLocation } from "../../utils/services/locations/UserLocationUtils";
import { getFileDownloadUrlList, refreshOrder, setOrderStatus } from "../../utils/services/oms/OMSUtils";
import { clearCartData, mapImageUrlToList, mergeRepeatOrderImagesWithCart, mergeRepeatOrderItemWithCart, updateRepeatOrderData } from "../../utils/services/oms/OMSCartUtils";

import { CommonOrderNowCTA } from "../../utils/widgets/CommonCTA";
import { CommonZeroScreen } from "../zero-screens/CommonZeroScreen";
import { OrderListShimmer } from "../shimmer-component/ScreenShimmer";
import { WAUpdateToggleView } from "../../utils/widgets/Common-Widget";

import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from '../../AppTheme';
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

import RateOrderModal from "../../utils/modals/RateOrderModal";
import ConfirmationPopup from "../../utils/modals/ConfirmationPopup";
import OrderListCardView from "../../utils/widgets/OrderDataCardView";

import ModalContent from "../../utils/constants/ModalContentConstant";

const OrderComponent = (props) => {

    const reduxState = store.getState()

    const activeOrderListRef = useRef<FlatList<any>>(null);
    const pastOrderListRef = useRef<FlatList<any>>(null);

    const [orderComponentInitialised, setComponentInitialised] = useState(false)

    const [orderList, setOrderList] = useState([])

    const [activeOrderList, updateActiveOrderList] = useState([])
    const [pastOrderList, updatePastOrderList] = useState([])

    const [selectedOrderData, setSelectedOrderData] = useState({})

    const [userOrderStat, setUserOrderSavings] = useState({
        totalOrders: 0, totalSavings: 0
    })
    const [orderDataLoaded, setOrderDataLoaded] = useState(false)

    const [showRatingModal, setRatingModal] = useState(false)
    const [reorderConfirmationModal, setReorderModal] = useState(false)

    const [waState, updateWAState] = React.useState({
        optInState: reduxState.whatsappOptInState,
        isOpted: reduxState.whatsappOptInState == 1 ? true : false
    })

    const repeateOrder = async (orderData, { clearCart = false }) => {

        if (!clearCart) clearCartData()

        let deliveryAddresss = orderData['deliveryAddress']
        getAddressFromUserSavedLocation(deliveryAddresss)

        if (orderData['medications'] &&
            orderData['medications'].length) {
            mergeRepeatOrderItemWithCart(orderData['medications'])
        } else if (orderData['prescription'] &&
            orderData['prescription']?.orgImages) {
            let prescriptionimgList = await getFileDownloadUrlList(
                orderData['prescription'].orgImages);
            if (prescriptionimgList.length) {
                let presImagesList = mapImageUrlToList(prescriptionimgList,
                    orderData['prescription']?.orgImages)
                mergeRepeatOrderImagesWithCart(presImagesList)
            }
        }

        if (orderData['note'])
            updateOrderInstructions(orderData['note'])

        updateRepeatOrderData(orderData)
        refreshChemistData({ storeId: orderData['pharmacyData']?.id })

        props.navigation.navigate(ScreenRoute.review_oms_order)
    }

    const reorder = (selectedOrderData) => {
        // if (getCartTotalItemCount())
        //     setReorderModal(true)
        // else repeateOrder(selectedOrderData, {})
        repeateOrder(selectedOrderData, {})
    }

    const closeReorderModal = () => {
        setReorderModal(false)
    }

    const updateMessageCount = (orderDetails, actionOrderIndex) => {
        // Updating too many end-points
        var activeList: any = activeOrderList
        orderDetails['pharmacyData']['unreadMsgCount'] = 0;
        orderList && orderList.forEach((order, i) => {
            if (order['oid'] == orderDetails['oid'])
                orderList[i] = orderDetails
        })
        activeList[actionOrderIndex] = orderDetails
        updateOrderList(orderList)
    }

    const updateRatedOrder = (ratedOrder) => {
        var pastList: any = pastOrderList
        orderList && orderList.forEach((order, index) => {
            if (order['oid'] == ratedOrder['oid']) {
                orderList[index]['feedback'] = ratedOrder['feedback']
            }
        })
        pastList.forEach((order, index) => {
            if (order['oid'] == ratedOrder['oid']) {
                pastList[index]['feedback'] = ratedOrder['feedback']
            }
        })
        updateOrderList(orderList)
    }

    const setRateOrderModal = () => {
        setRatingModal(true)
    }

    const closeRatingModal = () => {
        setRatingModal(false)
    }

    useEffect(() => {
        const reduxState = store.getState()
        if (isObjectNotEmpty(reduxState.userDetails['orderSavings']))
            setUserOrderSavings(reduxState.userDetails['orderSavings'])
        if (!orderComponentInitialised) {
            refreshOrder()
            orderSubscriptions()
            setComponentInitialised(true)
            store.subscribe(() => orderSubscriptions())
        }
    }, [])

    const orderSubscriptions = useCallback(
        debounce(() => getOrderList(), AppTheme.debouceTimeout * 2), [])

    const getOrderList = () => {
        const _reduxState: any = store.getState();
        if (_reduxState.orderList &&
            _reduxState.orderList.length > 0) {
            var pastOrderList: any = [];
            var activeOrderList: any = [];
            _reduxState.orderList.forEach((order) => {
                let orderData = setOrderStatus(order)
                orderData['isActiveOrder'] ?
                    activeOrderList.push(orderData) :
                    pastOrderList.push(orderData)
            })
            setOrderList(_reduxState.orderList)
            setOrderDataLoaded(true)
            setTimeout(() => updateActiveOrderList(activeOrderList), 100)
            setTimeout(() => updatePastOrderList(pastOrderList), 200)
        } else setOrderDataLoaded(true)
    }

    return (<ScrollView showsVerticalScrollIndicator={false}>

        {orderList && orderList.length ? <View style={{ marginBottom: 24 }}>

            {!!userOrderStat.totalOrders &&
                <AnimatableView animation="fadeIn" useNativeDriver={true}
                    duration={AppTheme.transitionDuration}
                    style={[AppStyles.bg, AppStyles.alignItemCenter]}>
                    <View style={[AppStyles.flexRowSpaceBetween, AppStyles.border12,
                    AppStyles.m16, AppStyles.px16, { backgroundColor: AppTheme.color.green.lightPrimary }]}>
                        <View style={{ marginVertical: 16, width: AppTheme.appWidth - 166 }}>
                            <Text style={[TextStyle.text16b, { flexWrap: "wrap" }]}>
                                You saved Rs {userOrderStat.totalSavings} on your last {userOrderStat.totalOrders} orders
                            </Text>
                            <Text style={[TextStyle.text12, { marginTop: 12 }]}>
                                Keep ordering to save more!</Text>
                        </View>
                        <View style={[AppStyles.flexRowEnd, { height: 96, alignItems: "flex-end" }]}>
                            <Image source={{
                                uri: getImagePath('/images/savingWithOrders.png')
                            }} style={{ marginLeft: 16, height: 81, width: 86, bottom: 0 }} />
                        </View>
                    </View>
                </AnimatableView>}

            {!waState.isOpted && <AnimatableView
                animation="fadeIn"
                duration={AppTheme.transitionDuration}
                style={{ marginHorizontal: 16, marginTop: 16 }}>
                <WAUpdateToggleView activity={'order'}
                    waState={waState} updateWAState={updateWAState} />
            </AnimatableView>}

            {activeOrderList.length > 0 && <View
                style={[AppStyles.bgWhite, AppStyles.px16, AppStyles.mt16]}>
                <Text style={[TextStyle.text16xb]}>
                    Active Orders</Text>
                <FlatList data={activeOrderList} ref={activeOrderListRef}
                    snapToAlignment="start" keyExtractor={item => item?.oid}
                    renderItem={({ item, index }) =>
                        <OrderListCardView index={index}
                            orderData={item} navigation={props.navigation}
                            updateMessageCount={updateMessageCount} />} />
            </View>}

            {pastOrderList.length > 0 && <View
                style={[AppStyles.bgWhite, AppStyles.px16, AppStyles.mt16]}>
                <Text style={[TextStyle.text16xb]}>
                    Past Orders</Text>
                <FlatList data={pastOrderList} ref={pastOrderListRef}
                    snapToAlignment="start" keyExtractor={item => item.oid}
                    renderItem={({ item, index }) =>
                        <OrderListCardView index={index}
                            orderData={item} navigation={props.navigation}
                            reorder={reorder} rateOrder={setRateOrderModal}
                            setSelectedOrderData={setSelectedOrderData} />} />
            </View>}

        </View> : orderDataLoaded ? <View>
            <CommonZeroScreen screenName={'noOrder'} />
            <CommonOrderNowCTA navigation={props.navigation} />
        </View> : <OrderListShimmer />}

        <ConfirmationPopup showPopup={reorderConfirmationModal}
            modalData={ModalContent.Reorder}
            closeModal={closeReorderModal}
            primaryAction={() => repeateOrder(selectedOrderData, {})}
            secondaryAction={() => repeateOrder(selectedOrderData, { clearCart: true })} />

        <RateOrderModal showRatingModal={showRatingModal}
            orderData={selectedOrderData}
            closeModal={closeRatingModal}
            primaryAction={updateRatedOrder} />

    </ScrollView>)
}

export default OrderComponent
